import { render, staticRenderFns } from "./refreshBtn.vue?vue&type=template&id=1c13dfd7&lang=pug"
import script from "./refreshBtn.vue?vue&type=script&lang=js"
export * from "./refreshBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports